export default __webpack_public_path__ + "static/media/refresh.cc9317ed.svg";